import { render, staticRenderFns } from "./Forgotpass.vue?vue&type=template&id=3888d013&"
import script from "./Forgotpass.vue?vue&type=script&lang=js&"
export * from "./Forgotpass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports